import {
  COOKIE_EXPIRES_DAYS,
  PROMO_CODE,
  REFERRAL_CODE,
} from '@toggle/helpers/src/constants';
import Cookies from 'js-cookie';

interface StoreReferralCodeProps {
  referralCode?: string;
  promoCode?: string;
}

export const setReferralPromoCookies = ({
  referralCode,
  promoCode,
}: StoreReferralCodeProps) => {
  if (referralCode) {
    Cookies.set(REFERRAL_CODE, referralCode, { expires: COOKIE_EXPIRES_DAYS });
  }

  if (promoCode) {
    Cookies.set(PROMO_CODE, promoCode, { expires: COOKIE_EXPIRES_DAYS });
  }
};
